/** Map backend menus.icon string → React icon component. */
import React from 'react';
import {
  FaHome,
  FaUser,
  FaPaperPlane,
  FaBuilding,
  FaBed,
  FaUtensils,
  FaUserTie,
  FaCreditCard,
  FaChartBar,
  FaLock,
  FaSignOutAlt,
  FaUserShield,
  FaFileInvoice,
} from 'react-icons/fa';

const ICONS = {
  home: FaHome,
  user: FaUser,
  'paper-plane': FaPaperPlane,
  building: FaBuilding,
  bed: FaBed,
  utensils: FaUtensils,
  'user-tie': FaUserTie,
  'credit-card': FaCreditCard,
  'chart-bar': FaChartBar,
  lock: FaLock,
  'sign-out': FaSignOutAlt,
  'user-shield': FaUserShield,
  'file-invoice': FaFileInvoice,
};

export function getMenuIcon(iconName) {
  const Comp = ICONS[iconName] || FaHome;
  return <Comp />;
}

export default ICONS;
